import { useAuth } from "@clerk/react-router";
import { useSendChatMessage } from "@noa/ui";
import { useLocation, useNavigate } from "react-router";

/**
 * Web chat composer hook — thin wrapper over the shared `useSendChatMessage` base, supplying
 * Clerk (`@clerk/react-router`) auth state. On the first message sent from Home it seamlessly
 * redirects to the conversation's own route (/conversation/:sessionId).
 */
export const useSendMessage = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useSendChatMessage(Boolean(isSignedIn), (sessionId) => {
    if (pathname === "/" && sessionId) navigate(`/conversation/${sessionId}`);
  });
};
